<template>
  <div
    class="flex gap-4 md:gap-7 flex-col md:flex-row items-start justify-between"
  >
    <Transition name="fade" mode="out-in">
      <div :key="loading" class="w-full">
        <template v-if="loading">
          <div class="w-full grid lg:grid-cols-3 gap-4">
            <CardWrapper
              class="p-3 border border-gray-250"
              v-for="el of 3"
              :key="el"
            >
              <div class="space-y-2">
                <CPreloader width="100px" height="18px" loading />
                <CPreloader width="150px" height="24px" loading />
              </div>
            </CardWrapper>
          </div>
        </template>
        <template v-else>
          <div>
            <div
              class="w-full grid md:grid-cols-2 lg:grid-cols-5 gap-2 md:hidden"
            >
              <CardWrapper class="p-4 border border-gray-250 rounded-xl">
                <StatisticsFilledCard
                  :title="$t('assigned_money')"
                  :profit="assignedMoney"
                  info-class="mb-1"
                />
              </CardWrapper>
              <div class="w-full grid grid-cols-2 gap-2">
                <CardWrapper
                  class="p-4 border border-gray-250 rounded-xl"
                  v-for="(item, idx) of mobileProfitStatisticsList"
                  :key="idx"
                >
                  <StatisticsFilledCard
                    :title="item?.title"
                    :profit="item?.profit"
                    :percentage="item?.percentage"
                    info-class="mb-1"
                  />
                </CardWrapper>
              </div>
            </div>
            <div class="w-full grid-cols-2 lg:grid-cols-5 gap-2 hidden md:grid">
              <CardWrapper
                class="p-3 border border-gray-250 rounded-xl"
                v-for="(item, idx) of statisticsList"
                :key="idx"
              >
                <StatisticsFilledCard
                  :title="item?.title"
                  :profit="item?.profit"
                  :percentage="item?.percentage"
                  info-class="mb-1"
                />
              </CardWrapper>
            </div>
          </div>
        </template>
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import CPreloader from "@/components/CPreloader.vue";
import StatisticsFilledCard from "@/modules/Dashboard/components/StatisticsFilledCard.vue";
import CardWrapper from "@/components/Card/CardWrapper.vue";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

interface Props {
  title: string;
  loading?: boolean;
  totalProfit: number;
  percentage: number;
  closedTrades: number;
  closedTradesPercentage: number;
  assignedMoney: number;
  last_week: number;
  last_month: number;
  last_week_percentage: number;
  last_month_percentage: number;
}

const props = defineProps<Props>();
const { t } = useI18n();

const mobileProfitStatisticsList = computed(() => [
  {
    title: t("this_week"),
    profit: props?.last_week,
    percentage: props?.last_week_percentage,
  },
  {
    title: t("this_month"),
    profit: props?.last_month,
    percentage: props?.last_month_percentage,
  },
  {
    title: t("dashboard_info.closed_trades"),
    profit: props?.closedTrades,
    percentage: props?.closedTradesPercentage,
  },
  {
    title: t("dashboard_info.total_profit"),
    profit: props?.totalProfit,
    percentage: props?.percentage,
  },
]);
const profitStatisticsList = computed(() => [
  {
    title: t("assigned_money"),
    profit: props?.assignedMoney,
  },
]);
const statisticsList = computed(() => [
  ...profitStatisticsList.value,
  ...mobileProfitStatisticsList.value,
]);
</script>

<style scoped></style>
